import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { bannerApi } from './api/bannerApi';
import { roomBookingApi } from './api/roomBookingApi';
import { roomApi } from './api/roomApi';
import { userApi } from "./api/userApi";
import { sevaApi } from "./api/sevaApi";

// import { roomBookingApi } from './api/roomBooking.Api';

export const store = configureStore({
    reducer: {
        [bannerApi.reducerPath]: bannerApi.reducer,
        [roomBookingApi.reducerPath]: roomBookingApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
        [roomApi.reducerPath]: roomApi.reducer,
        [sevaApi.reducerPath]: sevaApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([bannerApi.middleware, roomBookingApi.middleware, userApi.middleware, roomApi.middleware, sevaApi.middleware])

})
